(function () {
  const addFiltersHeight = () => {
		const middle = document.querySelector('.facets__wrapper');
		const bottom = document.querySelector('.catalog-page__bottom');
		if (!middle || !bottom) return;
		middle.style.paddingBottom = `${bottom.offsetHeight}px`
	}
  document.addEventListener("DOMContentLoaded", function () {
    addFiltersHeight();
    document.addEventListener("shopify:section:load", function () {
      addFiltersHeight();
    });
  });
	window.addEventListener("resize", function () {
		addFiltersHeight();
	});
})();
